module.exports = __webpack_public_path__ + "static/media/skill_level.2c0d29d4.svg";